import classNames from 'classnames/bind';
import { useState } from 'react';

import { withPriceSeperator } from '@flight-workspace/common-client/src/util/number';
import AgentInfo from 'common/agentInfo';
import OtaLogo from 'common/otaLogo';
import { getNeedNotice } from 'common/utils';
import styles from './index.module.scss';
import Notice from './notice';
import { IOta, IOtaFareList, IPassengerCount, OtaType } from './types';
import { areaCode, getTotalPrice } from './utils';

const cx = classNames.bind(styles);

interface AdsAirlineProps {
  adList: IOtaFareList[];
  passengerCount: IPassengerCount;
  onClickBooking: (ota: IOta, index: number) => () => void;
}

const AdsAirline = ({
  adList,
  passengerCount: { adultCnt, childCnt, infantCnt },
  onClickBooking,
}: AdsAirlineProps) => {
  const [noticeOta, setNoticeOta] = useState<IOta>();
  const [noticeIdx, setNoticeIdx] = useState<number>(0);
  const [isNoticeOn, setIsNoticeOn] = useState(false);

  if (
    adList.length < 1 ||
    adList.every(({ ota }) => ota?.otaId === undefined)
  ) {
    return <></>;
  }

  return (
    <div className={cx('AdsAirline')}>
      <div className={cx('option_list')}>
        {adList.map(({ ota, fare }, idx) => {
          const isFreeSameDayRefundable =
            ota?.refundPolicy?.isFreeSameDayRefundable &&
            fare?.isFreeSameDayRefundable;

          return (
            ota?.otaId && (
              <div className={cx('option')} key={idx}>
                <div className={cx('summary')}>
                  <div className={cx('logo')}>
                    <OtaLogo id={ota.otaId} name={ota.expName} />
                  </div>
                  <span className={cx('ota')}>
                    {ota.csInfo?.active || isFreeSameDayRefundable ? (
                      <AgentInfo
                        clickCodePrefix="idt"
                        otaIndex={idx + 1}
                        otaInfo={ota}
                        isFreeSameDayRefundable={isFreeSameDayRefundable}
                      />
                    ) : (
                      <i className={cx('name')}>{ota.expName}</i>
                    )}
                    <span className={cx('labels')}>
                      {(ota?.otaType === OtaType.KR_AIRLINE ||
                        ota?.otaType === OtaType.GLOBAL_AIRLINE) && (
                        <i className={cx('agent_airline')}>항공사</i>
                      )}
                      {ota?.otaType === OtaType.GLOBAL_OTA && (
                        <i className={cx('agent_foreign')}>해외여행사</i>
                      )}
                      {fare?.isHoneymoonBenefit && (
                        <b className={cx('honeymoon')}>허니문혜택</b>
                      )}
                    </span>
                  </span>
                  <div className={cx('desc')}>
                    <div className={cx('desc_inner')}>{ota?.adText}</div>
                  </div>
                  <strong className={cx('price')}>
                    <b className={cx('num')}>
                      {withPriceSeperator(
                        getTotalPrice(fare, adultCnt, childCnt, infantCnt),
                      )}
                    </b>
                    원
                  </strong>
                  <span className={cx('arrow')} />
                </div>
                <a
                  className={cx('link')}
                  data-event-nlog="click"
                  data-event-area-code={`${areaCode}.otabook${idx + 1}`}
                  onClick={
                    getNeedNotice(ota.otaId, ota.otaType)
                      ? () => {
                          setNoticeOta(ota);
                          setNoticeIdx(idx + 1);
                          setIsNoticeOn(true);
                        }
                      : onClickBooking(ota, idx + 1)
                  }
                />
              </div>
            )
          );
        })}
      </div>
      <div className={cx('provider')}>
        제공
        <span className={cx('logo_kayak')}>
          <span className={cx('blind')}>kayak</span>
        </span>
        <span className={cx('label_ad')}>
          <span className={cx('blind')}>광고</span>
        </span>
      </div>
      {isNoticeOn && (
        <Notice
          areaCode="idt"
          onClickBooking={onClickBooking(noticeOta!, noticeIdx)}
          onClose={() => setIsNoticeOn(false)}
        />
      )}
    </div>
  );
};

export default AdsAirline;
